module.exports = __webpack_public_path__ + "static/img/lv0.05c7d948.png";